import React from "react";

const SvgInfoInCircleFilled = props => <svg width={20} height={20} viewBox="0 0 20 20" {...props}><path fill="currentColor" fillRule="nonzero" d="M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0zm1.5 7.2h-3V17h3V7.2zm0-4.2h-3v2.8h3V3z" /></svg>;

export default "//cdn.scentbird.com/assets/frontbird-site/images/info-in-circle-filled_8b4b3b.svg";
export { SvgInfoInCircleFilled as ReactComponent };